import React, { useEffect, useRef, useState } from "react";
import ConversationHeader from "../../../components/Conversation Header";
import "./conversations.css";
import ConversationList from "../../../components/ConversationList";
import ChipButton from "../../../components/chip button";
import { chatSelector, globalStateSelector } from "../../../../../../store/selector";
import { chatAction, messageAction } from "../../../../../../store/action";
import { connect } from "react-redux";
import { MenuItem, Tab, Tabs } from "react-bootstrap";
import styled from "styled-components";
import { CustomDropdown } from "../../../../../common/components";
import Toggle from "react-toggle";

const getHeight = (headerRef) => {
  if (headerRef && headerRef.current && headerRef.current.clientHeight) {
    return `calc(100vh - ${headerRef.current.clientHeight}')`;
  }
};

const TabItemsStyle = styled.div`
  .tabItemStyle {
    display: flex;
    align-items: flex-end;
    height: 52px;
    padding: 0px 20px;
    border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    position: relative;
    flex-flow: row-reverse wrap;
    -webkit-box-pack: start;
    justify-content: flex-start;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
  }

  ul > li > a {
    position: relative;
    padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  ul > li.active > a,
  ul > li.active > a:focus,
  ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  li > a:hover {
    background: #fff !important;
    color: rgb(53, 72, 105);
    font-weight: 600;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }
`;

const StatusStyle = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 12px 0px 4px;
  gap: 3px;
  
  .react-toggle-track {
    width: 35px !important;
    height: 16px !important;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 20px !important;
    top: 2px !important;
  }

  .react-toggle-thumb{
    width: 12px !important;
    height: 12px !important;
    top: 2px !important;
  }

  .textStatus {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

const OfflineView = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  gap: 8px;
  border: 1px solid #FFAEA8;
  background: #FFECE9;
  justify-content: center;
  height: 50px;

  .offline-icon {
    font-size: 22px;
    color: #EA1B4C;
  }

  .offline-text {
    font-weight: 500;
    font-size: 20px;
    color: #EA1B4C;
    letter-spacing: 0.03em;
  }
`;

function index({
  unAssignedList,
  profile,
  assignedList,
  status,
  assignScreen,
  newUnAssignedUsers,
  dynamicUpdate,
  disposeList,
  disposeScreen,
  ...props
}) {
  // const [assignScreen, setAssignScreen] = useState(true);
  const { configProcessor, isConnected, isOffline } = props;

  const setAssignScreen = (value) => {
    if (value === false) {
      dynamicUpdate({ data: { key: "details.newUnAssignedUsers", value: 0 } });
    }
    dynamicUpdate({ data: { key: "details.assignScreen", value: value } });
  };

  const assignOnClick = (e) => {
    e.preventDefault();
    setAssignScreen(true);
  };

  // const goOnline = () => {
  //   configProcessor("goOnline", { userState: "online" });
  // };
  // const goOffline = () => {
  //   configProcessor("goOnline", { userState: "offline" });
  // };

  // const changeStatus = () => {
  //   if (status === "offline") {
  //     goOnline();
  //   } else {
  //     goOffline();
  //   }
  // };

  const updateStatus = (newState) => {
    configProcessor("goOnline", { userState: newState });
  };
  const changeStatus = () => {
    updateStatus(status === "offline" ? "online" : "offline");
  };


  const unAssignOnClick = (e) => {
    e.preventDefault();
    setAssignScreen(false);
    // props.setDisposeScreen(false);
    // props.setActiveTab("reply");
    // dispatch(
    //   chatAction.dynamicUpdate({
    //     data: { key: "selectedAssignedList", value: {} },
    //   })
    // );
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
      <div className="conversations__row-view">
        {/* <ConversationHeader profile={profile} type="header" status={status} /> */}
        <div className="conversation-buttons-wrapper">
          {/* <TabItemsStyle>
          <div className="tabItemStyle">
            <Tabs defaultActiveKey="assigned" id="">
              <Tab eventKey="assigned" title="Assigned">

              </Tab>
              <Tab eventKey="un-assigned" title="Un-assigned"></Tab>
            </Tabs>
          </div>
        </TabItemsStyle> */}
          <div className="conversation-button-inner_wrapper">
            <ChipButton
              className="chip-button__assign_border"
              selected={assignScreen}
              onClick={assignOnClick}
            >
              Assigned
            </ChipButton>
            <ChipButton
              selected={!assignScreen}
              onClick={unAssignOnClick}
              count={unAssignedList.length}
              className="chip-button__unassign_border"
              disabled={status === "offline" ? true : false}
            >
              Un-assigned
            </ChipButton>
            {/* <CustomDropdown style={{minHeight: "52px", borderLeft: "1px solid #D1D9E0"}}>
              <MenuItem onClick={() => changeStatus()}>
                Go {status === "online" ? "Offline" : "Online"}
              </MenuItem>
            </CustomDropdown> */}
            <StatusStyle>
              <Toggle
                // disabled={!isAccess(this.props.access, "edit")}
                checked={status === "online"}
                // defaultChecked={status}
                icons={{
                  checked: <span>Yes</span>,
                  unchecked: <span>No</span>,
                }}
                onChange={() => changeStatus()}
              />
              <span className="textStatus" style={{ color: status === "online" ? '#4CB944' : '#647491' }}>{status === "online" ? "Online" : "Offline"}</span>
            </StatusStyle>
          </div>
        </div>
        <div className="conversations__list">
          <ConversationList
            showAssignButton={assignScreen ? false : true}
            canSelectCustomer={assignScreen ? true : true}
            conversationList={assignScreen ? assignedList : unAssignedList}
            disposeList={assignScreen ? disposeList : ''}
            setAssignScreen={setAssignScreen}
          />
        </div>
        {(isOffline || !isConnected) ? (
          <OfflineView>
            <span class="material-symbols-outlined offline-icon">
              wifi_off
            </span>
            <span className="offline-text">You are Offline</span>
          </OfflineView>
        ) : ("")}
      </div>
      {/* <div>
        <div className="conversations__row-view">
          <div className="conversation-buttons-wrapper">
            <div className="conversation-button-inner_wrapper">
              <ChipButton
                className="chip-button__assign_border"
              selected={disposeScreen}
              // onClick={assignOnClick}
              >
                Dispose
              </ChipButton>
            </div>
          </div>
          <div className="conversations__list">
            <ConversationList
              showAssignButton={false}
              canSelectCustomer={true}
              conversationList={disposeList}
              setAssignScreen={setAssignScreen}
              disposeCustomer={true}
            />
          </div>
        </div>
      </div> */}
    </div>
  );
}

const stateToProps = (state) => ({
  assignScreen: chatSelector.getChatDynamic(state, "details.assignScreen"),
  disposeScreen: chatSelector.getChatDynamic(state, "disposeScreen"),
  newUnAssignedUsers: chatSelector.getChatDynamic(
    state,
    "details.newUnAssignedUsers"
  ),
  isConnected: globalStateSelector.getIsConnected(state),
  isOffline: globalStateSelector.getIsOffline(state),
});

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
  setDisposeScreen: (data) => {
    dispatch(chatAction.setDisposeScreen(data));
  },
  setActiveTab: (data) => {
    dispatch(chatAction.setActiveTab(data));
  },
});

export default connect(stateToProps, dispatchToProps)(index);

// export default index;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/modules/leftContent/conversations/index.js